import ids from './ids';

export default {
  ids,
};
